export default __webpack_public_path__ + "icon-arrow-right-hover.png?309dd28296a113a34a62b504debfdf82";